// min / max over numbers and arrays without spreading them into a call (a spread of a long array overflows the
// call stack: "Maximum call stack size exceeded", user 7 Oct 2026). NaN-free like Math.min / Math.max on finite data.
const walk = (args, better, start) => {
  let m = start;
  for (let a = 0; a < args.length; a += 1) {
    const x = args[a];
    if (x !== null && typeof x === 'object' && typeof x.length === 'number') { for (let i = 0; i < x.length; i += 1) if (better(x[i], m)) m = x[i]; }
    else if (better(x, m)) m = x;
  }
  return m;
};
export const amin = (...args) => walk(args, (v, m) => v < m || Number.isNaN(v), Infinity);
export const amax = (...args) => walk(args, (v, m) => v > m || Number.isNaN(v), -Infinity);
